export enum CustomEventsName {
  LOAD_EMAIL_MODULE = 'load-email-module',
}
